<template>
    <div class="select-field" :class="displayClass">
        <div class="field-container">
            <Dropdown 
                v-model="selected" 
                :options="options" 
                optionValue="value" 
                optionLabel="label" 
                :placeholder="placeholder"
                :filter="filter"
                @change="updateValue"
            />
            <div v-if="icon" class="field-icon" @click="openSelect">
                <i :class="'icon-'+icon"></i>
            </div>
        </div>        
        <div class="invalid-feedback" v-if="errors" v-text="errors"></div>
    </div>
</template>

<script>
    import Dropdown from 'primevue/dropdown/sfc';

    export default {
        props: [
            'modelValue',
            'placeholder',
            'displayClass',
            'errors',
            'icon',
            'options',
            'filter'
        ],

        emits: [
            'update:modelValue'
        ],

        components: {
            Dropdown
        },

        data() {
            return {
                selected: null
            }
        },

        watch: {
            modelValue(newValue) {
                this.selected = newValue
            }
        },

        methods: {
            updateValue() {
                this.$emit('update:modelValue', this.selected)
            },
        }
    }
</script>